import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import DnsIcon from "@mui/icons-material/Dns";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";
import SurfingIcon from "@mui/icons-material/Surfing";
import AnalyticsSharpIcon from "@mui/icons-material/AnalyticsSharp";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import SummarizeIcon from '@mui/icons-material/Summarize';
import VerifiedIcon from '@mui/icons-material/Verified';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WarehouseIcon from "@mui/icons-material/Warehouse";
// import WorkHistoryIcon from "@mui/icons-material/WorkHistory";

export const adminDashboardMenu = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
  },
  {
    name: "Organization",
    icon: <CorporateFareIcon />,
    submenu: [
      // {
      //   name: "User Request",
      //   path: "/user/requests",
      //   icon: <WorkHistoryIcon />,
      // },
      {
        name: "User",
        path: "/user",
        icon: <PeopleIcon />,
      },
      // {
      //   name: "Warehouse",
      //   path: "/warehouse",
      //   icon: <WarehouseIcon />,
      // },
    ],
  },
  {
    name: "Orders",
    icon: <ShoppingCartCheckoutIcon />,
    submenu: [
      {
        name: "Orders",
        path: "/orders",
        icon: <ShoppingCartCheckoutIcon />,
      },
      {
        name: "NDR Orders",
        path: "/ndrorders",
        icon: <AnalyticsSharpIcon />,
      },
      {
        name: "User Orders",
        path: "/userorders",
        icon: <PeopleIcon />,
      },
      // {
      //   name: "Report Section",
      //   path: "/reportsection",
      //   icon: <PeopleIcon />,
      // },
    ],
  },
  {
    name: "Report",
    icon: <SummarizeIcon />,
    submenu: [
      {
        name: "Report Section",
        path: "/reportsection",
        icon: <FileDownloadIcon />,
      },  
      {
        name: "Payment Verfication",
        path: "/payment-verification",
        icon: <VerifiedIcon />,
      },
    ],
  },
  {
    name: "returns",
    path: "/admin/returns",
    icon: <AssignmentReturnIcon />,
  },

  {
    name: "Products",
    path: "/products",
    icon: <DnsIcon />,
  },
  {
    name: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
];

export const userDashboardMenu = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
  },
  {
    name: "Orders",
    icon: <ShoppingCartCheckoutIcon />,
    submenu: [
      {
        name: "Orders",
        path: "/orders",
        icon: <ShoppingCartCheckoutIcon />,
      },
      {
        name: "NDR Orders",
        path: "/ndrorders",
        icon: <AnalyticsSharpIcon />,
      },
      // {
      //   name: "Leave Analytics",
      //   path: "/leaveAnalytics",
      //   icon: <AnalyticsSharpIcon />,
      // },
    ],
  },
    {
    name: "Report",
    icon: <SummarizeIcon />,
    submenu: [
      {
        name: "Report Section",
        path: "/reportsection",
        icon: <FileDownloadIcon />,
      },  
      {
        name: "Payment Verfication",
        path: "/payment-verification",
        icon: <VerifiedIcon />,
      },
    ],
  },
];

export const wareHouseDashboardMenu = [
  // {
  //   name: "Dashboard",
  //   path: "/dashboard",
  //   icon: <DashboardIcon />,
  // },
  {
    name: "Orders",
    icon: <ShoppingCartCheckoutIcon />,
    submenu: [
      {
        name: "Orders",
        path: "/warehouse/orders",
        icon: <ShoppingCartCheckoutIcon />,
      },
      {
        name: "returns",
        path: "/warehouse/returns",
        icon: <AssignmentReturnIcon />,
      },
    ],
  },
];
